import colors from "@/lib/theme/colors"

const XIconThin = ({
  color = colors.directBlack,
  ...props
}: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.75 5.25L5.25 18.75"
        stroke={color || "#231F20"}
        stroke-linecap="square"
        stroke-linejoin="round"
      />
      <path
        d="M18.75 18.75L5.25 5.25"
        stroke={color || "#231F20"}
        stroke-linecap="square"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default XIconThin
